
import { Vue, Options } from 'vue-class-component'
let instanceCounter = 0
@Options({ name: 'KeyPeriod', props: { width: { type: [Number, String], default: 56 }, height: { type: [Number, String], default: 40 } } })
export default class KeyPeriod extends Vue {
  private instanceId = `keyPeriod-${++instanceCounter}`
  get glossId(): string { return `${this.instanceId}-gloss` }
  get highlightId(): string { return `${this.instanceId}-highlight` }
}
